// src/hooks/useScrollLock.tsx
import { useEffect, useRef } from 'react';

/**
 * Блокировка прокрутки body (модалки/оверлеи).
 * Без побочных эффектов за пределами body style; безопасный restore.
 */
export function useScrollLock(active: boolean) {
  const saved = useRef<{ overflow: string; paddingRight: string } | null>(null);

  useEffect(() => {
    if (!active) return;
    const doc = document;
    const body = doc.body;
    const prev = {
      overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
    };
    saved.current = prev;

    const scrollbar = window.innerWidth - doc.documentElement.clientWidth;
    body.style.overflow = 'hidden';
    if (scrollbar > 0) body.style.paddingRight = `${scrollbar}px`;

    return () => {
      if (saved.current) {
        body.style.overflow = saved.current.overflow;
        body.style.paddingRight = saved.current.paddingRight;
      }
    };
  }, [active]);
}